import React from "react";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import { mutate } from "swr";

import { store } from "@components/VerticalLayout/store";
import { resetAllPeripherals } from "../../DeviceAssociateModal/store";
import { store as userStore } from "@components/VerticalLayout/store";
import {
    resetMoneticData,
    setMoneticData,
    store as moneticDataStore,
} from "./store";
import {
    store as generalStore,
    setIsActionsClicked,
    setActions,
} from "../../store";

import {
    AdyenCurrencies,
    ipMatchWord,
    numberMatchWord,
} from "../../../../constants";
import { resetPrinterData } from "../PrinterPeripheralConfigure/store";
import { resetCashManagementData } from "../CashManagementPeripheralConfigure/store";
import { verifyIfPeripheralAssociate } from "../../../../helpers/peripheralsHelpers";
import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";

type FooterType = {
    setDataIsUpdated: Function;
    editedData: any;
    selectedRows: any;
    isAddPeripheralClicked: boolean;
    isEdited: boolean;
    setIsAddPeripheralClicked: Function;
    setEditedData: Function;
    setIsEdited: Function;
    setIsConfirmationEditModalOpened: Function;
    shopIds: any;
    isConsult: any;
    setIsConsult: Function;
};

export function CardFooter({
    setEditedData,
    setDataIsUpdated,
    editedData,
    selectedRows,
    isAddPeripheralClicked,
    isEdited,
    setIsAddPeripheralClicked,
    setIsEdited,
    setIsConfirmationEditModalOpened,
    shopIds,
    isConsult,
    setIsConsult,
}: FooterType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const notStartWithSpaceRegExp = new RegExp(/^\S/);
    const { franchiseID, userID } = useSnapshot(store);
    const [canValidate, setCanValidate] = React.useState<boolean>(true);
    const [error, setError] = React.useState<boolean>(false);
    const { isActionsClicked } = useSnapshot(generalStore);
    const { oneShop, shopID, resourceIp, operatorID } = useSnapshot(userStore);
    const shopId = oneShop ? shopID : selectedRows?.shopId;
    const appId = "KIOSK";
    const uuidUser = localStorage.getItem("uuidUser");
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";

    let ifPeripheralAssociateObject: {
        isPeripheralAssociate: boolean;
        appId_children: any[];
    };
    const {
        designation,
        mark,
        reference,
        note,
        merchantCode,
        paymentType,
        url,
        port,
        speed,
        ipAddress,
        isNameExist,
        deviceCode,
        kiss,
        typeConfig,
        isModalOpened,
        nomTpe,
        typeTerminal,
        timeout,
        inputTimeout,
        inputPaymentMethod,
        paymentMethod,
        ipExist,
        emptyIp,
        webhook,
        adyenIpAddress,
        mode,
        adyenIpExist,
        idIntegrator,
        autoValidate,
        currency,
        adyenConfig,
    } = useSnapshot(moneticDataStore);

    function makeId(length: any) {
        var result = "";
        var characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }
    async function RedisPublishPeripheral() {
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/peripheral/redis`;
        try {
            const data: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    shopId: oneShop ? shopID : shopId,
                }),
                method: "POST",
            });
            if (data.error) {
                throw Error("Error while saving selection!");
            }
            mutate(apiUrl, data);
        } catch (e: any) {
            console.log(`${t("There's an error")}!`);
        }
    }
    async function isCurrencyExistInShop(shopId: string) {
        toast.dismiss();
        let currencyExist = "";

        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/devise?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=activated`;
        try {
            const result: any = await fetchGlobal(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },
            });
            mutate(url, result);
            if (result.data.length !== 0) {
                if (
                    AdyenCurrencies.find(
                        (el: any) => el.code === result.data[0][t("Currency")]
                    ) !== undefined &&
                    result.data[0].isActive === true
                ) {
                    currencyExist = result.data[0][t("Currency")];
                }
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        return currencyExist;
    }
    async function addMonetics() {
        let hasIpConflict: number = 0;

        if (canValidate) {
            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/monetics`;
            let shop = oneShop ? [shopID] : shopIds;
            if (
                Object.keys(adyenConfig || {}).length === 0 &&
                mark === "Adyen"
            ) {
                ErrorToast(
                    t(
                        "To add an Adyen payment terminal, you must fill in the fields of the 'Adyen Configuration.'"
                    )
                );
            } else {
                let isNotInclude: boolean = false;
                let isInclude: boolean = false;

                setCanValidate(false);
                for (let element of shop) {
                    let filteredData = JSON.parse(JSON.stringify(resourceIp))
                        ?.filter(
                            (item: any) =>
                                item?.shopId === element &&
                                item.ip.trim() !== ""
                        )
                        .map((y: any) => {
                            return y.ip;
                        });
                    filteredData = [...new Set(filteredData)];
                    if (filteredData.includes(ipAddress)) {
                        hasIpConflict++;
                    }
                    if (!filteredData.includes(ipAddress)) {
                        let isCurrencyExist: any = await isCurrencyExistInShop(
                            element
                        );
                        if (
                            (isCurrencyExist !== "" && mark === "Adyen") ||
                            mark !== "Adyen"
                        ) {
                            isInclude = true;
                            let data = {
                                userId: userID,
                                shopId: element,
                                franchiseId: franchiseID,
                                operatorId: operatorID,
                                uuidUser: uuidUser,
                                data: [
                                    {
                                        id: makeId(10),
                                        designation: designation.trim(),
                                        mark: mark,
                                        reference: reference,
                                        note: note,
                                        shopId: oneShop ? shopID : shopId,
                                        merchant_code: merchantCode,
                                        device_code: deviceCode,
                                        port: port,
                                        url: url,
                                        speed: speed,
                                        setup_type: typeConfig,
                                        ip: ipAddress,
                                        payment_type: paymentType,
                                        payment_method: paymentMethod,
                                        timeout: timeout,
                                        kiss: kiss,
                                        terminal_type: typeTerminal,
                                        isArchived: false,
                                        adyenIp: adyenIpAddress,
                                        mode: mode,
                                        webhook: webhook,
                                        idIntegrator: idIntegrator,
                                        autoValidate: autoValidate,
                                        currency: currency,
                                        adyenConfig:
                                            mark === "Adyen"
                                                ? {
                                                      ...adyenConfig,
                                                      currency: isCurrencyExist,
                                                  }
                                                : adyenConfig,
                                    },
                                ],
                            };

                            const requestOptions = {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(data),
                            };

                            try {
                                const data: any = await fetchGlobal(
                                    apiUrlAdd,
                                    requestOptions
                                );
                                if (data.error) {
                                    throw Error("error");
                                }

                                mutate(apiUrlAdd, data);
                            } catch (e: any) {
                                setCanValidate(true);
                                setError(true);
                                toast.error(`${t("There's an error")!}`, {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 2000,
                                    theme: "colored",
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                });
                            }
                        } else if (isCurrencyExist === "" && mark === "Adyen") {
                            isNotInclude = true;
                        }
                    }
                }

                if (error === false && isInclude) {
                    toast.success(`${t("The device is successfully added")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    });
                }
                if (hasIpConflict > 0) {
                    ErrorToast(
                        t(
                            "Please note, the device could not be added to one or more stores. Please check the IP address settings."
                        )
                    );
                }
                if (isNotInclude) {
                    ErrorToast(
                        t(
                            "Caution, the addition could not be successfully completed for one or more stores. Please check the currency settings in the general settings ."
                        )
                    );
                    setDataIsUpdated!(true);
                }
                resetMoneticData();
                setDataIsUpdated!(true);
                resetAllPeripherals();
                resetPrinterData();
                resetCashManagementData();
                resetMoneticData();
                setEditedData([]);
                setIsEdited(false);
                activateCheckbox();
                setCanValidate(true);
            }
        }
    }
    async function editMonetics() {
        if (canValidate) {
            setCanValidate(false);

            ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                editedData.id_monetic,
                shopId,
                franchiseID,
                userID,
                appId,
                fetchGlobal
            );

            const apiUrlUpdate = `${process.env.REACT_APP_API_V2_URL}/settings/monetics/configuration?isPeripheralAssociate=${ifPeripheralAssociateObject.isPeripheralAssociate}`;

            let dataConfig = {
                userId: userID,
                shopId: shopId,
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                appId: appId,
                appId_children: ifPeripheralAssociateObject.appId_children,
                peripheralId: editedData.id_monetic,
                data: [
                    {
                        id: editedData.id_monetic,
                        designation: designation.trim(),
                        tpe_name: nomTpe,
                        reference: reference,
                        note: note,
                        android: "android",
                        merchant_code: merchantCode,
                        speed: speed,
                        device_code: deviceCode,
                        port: port,
                        url: url,
                        shopId: shopId,
                        kiss: kiss,
                        setup_type: typeConfig,
                        ip: ipAddress,
                        payment_type: paymentType,
                        mark: mark,
                        payment_method: paymentMethod,
                        timeout: timeout,
                        terminal_type: typeTerminal,
                        isArchived: false,
                        adyenIp: adyenIpAddress,
                        mode: mode,
                        webhook: webhook,
                        idIntegrator: idIntegrator,
                        autoValidate: autoValidate,
                        currency: currency,
                        adyenConfig: adyenConfig,
                    },
                ],
            };

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };

            try {
                const data: any = await fetchGlobal(
                    apiUrlUpdate,
                    requestOptions
                );
                if (data.error) {
                    throw Error("Error !");
                }
                mutate(apiUrlUpdate, data);
                if (ifPeripheralAssociateObject.isPeripheralAssociate)
                    setTimeout(RedisPublishPeripheral, 3000);
                setCanValidate(true);
                resetCashManagementData();
                setDataIsUpdated!(true);
                resetAllPeripherals();
                resetPrinterData();
                resetCashManagementData();
                resetMoneticData();
                setEditedData([]);
                setIsEdited(false);
                activateCheckbox();
                toast.success(`${t("The device was successfully changed")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    theme: "colored",
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                });
            } catch (e: any) {
                setCanValidate(true);
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }
    const handleValidate = () => {
        if (mark === "") {
            setMoneticData(true, "selectMark");
        }
        if (designation === "") {
            setMoneticData(true, "inputDesignation");
        }
        if (speed === "") {
            setMoneticData(true, "speedSelectInput");
        }
        if (port === "") {
            setMoneticData(true, "portSelectInput");
        }

        if (paymentType === "") {
            setMoneticData(true, "SelectInput");
        }
        if (ipAddress === "") {
            setMoneticData(true, "emptyIp");
        }

        if (!ipAddress.match(ipMatchWord)) {
            setMoneticData(true, "inputIp");
        }
        if (adyenIpAddress === "") {
            setMoneticData(true, "inputAdyenIpAddress");
        }
        if (webhook === "") {
            setMoneticData(true, "inputWebHook");
        }
        if (mode === "") {
            setMoneticData(true, "inputMode");
        }
        if (idIntegrator === "") {
            setMoneticData(true, "inputIdIntegrator");
        }
        if (autoValidate === "") {
            setMoneticData(true, "inputAutoValidate");
        }
        if (currency === "") {
            setMoneticData(true, "inputCurrency");
        }

        if (editedData[t("IP address")] !== undefined) {
            let filteredData = JSON.parse(JSON.stringify(resourceIp))
                ?.filter(
                    (item: any) =>
                        item?.shopId === shopId &&
                        item.ip.trim() !== "" &&
                        item.ip.trim() !== editedData[t("IP address")] &&
                        item.ip.trim() !== editedData.ip
                )
                .map((y: any) => {
                    return y.ip;
                });
            filteredData = [...new Set(filteredData)];
            if (filteredData.includes(ipAddress)) {
                setMoneticData(true, "ipExist");
            }
        }
        if (
            editedData[t("IP address")] !== undefined &&
            editedData[t("Mark")] === "Adyen"
        ) {
            let filteredData = JSON.parse(JSON.stringify(resourceIp))
                ?.filter(
                    (item: any) =>
                        item?.shopId === shopId &&
                        item.ip.trim() !== "" &&
                        item.ip.trim() !== editedData.ip &&
                        item.ip.trim() !== editedData.adyenIp
                )
                .map((y: any) => {
                    return y.ip;
                });

            filteredData = [...new Set(filteredData)];
            if (filteredData.includes(adyenIpAddress)) {
                setMoneticData(true, "adyenIpExist");
            }
        }
        if (port === "") {
            setMoneticData(true, "inputPort");
        }
        if (merchantCode === "") {
            setMoneticData(true, "InputCode");
        }

        if (url === "") {
            setMoneticData(true, "InputUrl");
        }
        if (timeout === "") {
            setMoneticData(true, "inputTimeout");
        }

        if (
            paymentMethod !== undefined &&
            Object.keys(paymentMethod).length === 0
        ) {
            setMoneticData(true, "inputPaymentMethod");
        }
        if (Object.keys(typeConfig).length === 0) {
            setMoneticData(true, "inputSetupType");
        }
        if (Object.keys(typeTerminal).length === 0) {
            setMoneticData(true, "inputTerminalType");
        }
        if (editedData.id_monetic) {
            if (
                (mark === "Valina" &&
                    designation.length !== 0 &&
                    reference !== "" &&
                    port !== "" &&
                    speed !== "" &&
                    !isNameExist &&
                    designation.trim() !== "" &&
                    inputPaymentMethod === false &&
                    inputTimeout === false &&
                    designation.match(notStartWithSpaceRegExp)) ||
                (mark === "Nepting" &&
                    Object.keys(typeConfig).length > 0 &&
                    Object.keys(typeTerminal).length > 0 &&
                    designation.length !== 0 &&
                    reference !== "" &&
                    ipAddress !== "" &&
                    port !== "" &&
                    merchantCode !== "" &&
                    url !== "" &&
                    paymentType !== "" &&
                    ipExist === false &&
                    Number(port) &&
                    emptyIp === false &&
                    ipAddress.match(ipMatchWord) &&
                    !isNameExist &&
                    designation.trim() !== "" &&
                    designation.match(notStartWithSpaceRegExp)) ||
                (mark === "Adyen" &&
                    designation.length !== 0 &&
                    ipAddress !== "" &&
                    emptyIp === false &&
                    port !== "" &&
                    webhook !== "" &&
                    ipExist === false &&
                    adyenIpExist === false &&
                    ipAddress.match(ipMatchWord) &&
                    webhook.match(numberMatchWord) &&
                    port.match(numberMatchWord) &&
                    !isNameExist &&
                    designation.trim() !== "" &&
                    designation.match(notStartWithSpaceRegExp)) ||
                (mark === "Valina swiss" &&
                    designation.length !== 0 &&
                    !isNameExist &&
                    designation.trim() !== "" &&
                    designation.match(notStartWithSpaceRegExp) &&
                    idIntegrator !== "" &&
                    autoValidate !== "" &&
                    currency !== "")
            ) {
                if (isEdited === false) {
                    setMoneticData(!isModalOpened, "isModalOpened");
                    setIsConfirmationEditModalOpened(true);
                } else {
                    editMonetics();
                    setIsAddPeripheralClicked(!isAddPeripheralClicked);
                }
            }
        } else if (
            (mark === "Valina" &&
                designation.length !== 0 &&
                reference !== "" &&
                port !== "" &&
                speed !== "" &&
                !isNameExist &&
                designation.trim() !== "" &&
                inputPaymentMethod === false &&
                inputTimeout === false &&
                designation.match(notStartWithSpaceRegExp)) ||
            (mark === "Nepting" &&
                Object.keys(typeConfig).length > 0 &&
                Object.keys(typeTerminal).length > 0 &&
                designation.length !== 0 &&
                reference !== "" &&
                ipAddress !== "" &&
                emptyIp === false &&
                port !== "" &&
                merchantCode !== "" &&
                url !== "" &&
                paymentType !== "" &&
                ipExist === false &&
                Number(port) &&
                ipAddress.match(ipMatchWord) &&
                !isNameExist &&
                designation.trim() !== "" &&
                designation.match(notStartWithSpaceRegExp)) ||
            (mark === "Adyen" &&
                designation.length !== 0 &&
                ipAddress !== "" &&
                emptyIp === false &&
                port !== "" &&
                webhook !== "" &&
                ipExist === false &&
                adyenIpExist === false &&
                !isNameExist &&
                designation.trim() !== "" &&
                designation.match(notStartWithSpaceRegExp)) ||
            (mark === "Valina swiss" &&
                designation.length !== 0 &&
                !isNameExist &&
                designation.trim() !== "" &&
                designation.match(notStartWithSpaceRegExp) &&
                idIntegrator !== "" &&
                autoValidate !== "" &&
                currency !== "" &&
                typeTerminal !== "")
        ) {
            if (shopId === undefined) {
                ErrorToast(`${t("Attention ! you must select a store.")!}`);
            } else {
                addMonetics();
            }
        }
    };

    const activateCheckbox = () => {
        let checks = document.getElementsByClassName("PrivateSwitchBase-input");
        for (let i = 0; i < checks.length; i++) {
            checks[i].classList.remove("not-allowed-icon-check__clz");
        }
    };

    return (
        <React.Fragment>
            <CustomSecondaryColorButton
                outline
                rounded
                variant="light"
                className="mr-2 afp_btn_FRcancel cmn_btn_cancel"
                onClick={() => {
                    if (isEdited === true) {
                        setIsActionsClicked(!isActionsClicked);
                        setActions(() => {
                            setIsAddPeripheralClicked(!isAddPeripheralClicked);
                            resetMoneticData();
                            resetAllPeripherals();
                            resetPrinterData();
                            resetCashManagementData();
                            resetMoneticData();
                            setEditedData([]);
                            setIsEdited(false);
                            activateCheckbox();
                        });
                    } else {
                        setIsAddPeripheralClicked(!isAddPeripheralClicked);
                        resetMoneticData();
                        resetAllPeripherals();
                        resetPrinterData();
                        resetCashManagementData();
                        resetMoneticData();
                        setEditedData([]);
                        setIsEdited(false);
                        activateCheckbox();
                    }
                    setIsConsult(false);
                }}
            >
                <span> {t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                variant="primary"
                className={`afp_btn_FRvalidate cmn_btn_validate ${
                    isConsult ? "not-allowed-icon__clz" : ""
                }`}
                onClick={handleValidate}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </React.Fragment>
    );
}
